export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./news.vue?vue&type=template&id=6f695832&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/news.vue?vue&type=template&id=6f695832&
// module id = 86
// module chunks = 0